var path = 'components/common/components/assignContentSets/tooltips/contentItemPriceErrorTooltip.html';
var html = "<p style=width:150px>You do not have an access to solve the pricing conflicts. Please, unassign conflicted content sets from this content.</p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;